module.exports = __webpack_public_path__ + "website/img/paas_01.3b693064.png";